<!--
    描述： 六算分析表 -- 基础信息模块
    时间： xx
    created by ws
-->
<template>
	<div class="table-layout">
		<div class="table-content"
			 ref="tableContent">
			<el-table class="w100 h100"
					  :height="tableH"
					  :data="tableData"
					  highlight-current-row
					  v-loading="loading"
					  stripe>
				<el-table-column prop="sname"
								 label="信息名称"
								 header-align="center"
								 align="center"
								 min-width="150">
				</el-table-column>
				<el-table-column prop="estimateMoney"
								 label="概算价"
								 header-align="center"
								 align="right"
								 min-width="130">
				</el-table-column>
				<el-table-column prop="controlMoney"
								 label="控制价"
								 header-align="center"
								 align="right"
								 min-width="120">
				</el-table-column>
				<el-table-column prop="biddingMoney"
								 label="中标价"
								 header-align="center"
								 align="right"
								 min-width="120">
				</el-table-column>
				<el-table-column prop="reportMoney"
								 label="报审价"
								 header-align="center"
								 align="right"
								 min-width="120">
				</el-table-column>
				<el-table-column prop="beforeMoney"
								 label="初审价"
								 header-align="center"
								 align="right"
								 min-width="120">
				</el-table-column>
				<el-table-column prop="afterMoney"
								 label="审定价"
								 header-align="center"
								 align="right"
								 min-width="120">
				</el-table-column>
			</el-table>
		</div>
	</div>
</template>

<script>
import { getSheetAnalysis } from '@/api/modules/analysisCharts'
import { mapState } from 'vuex'
export default {
	name: 'analysis-sheet-info',
	data() {
		return {
			query: {
				id: ''
			},
			tableH: 294,
			tableData: [],
			loading: false
		}
	},
	methods: {
		// 主表接口
		getMainData() {
			this.loading = true
			this.tableData = []
			getSheetAnalysis({id: this.curProjectId}).then(res => {
				this.loading = false;
				if (res.code ===0) {
					this.tableData = res.data.busProContractCosts
					// console.log(JSON.stringify(this.tableData));
				}
			}).catch(err => {
				this.loading = false
			})
		}
	},
	created() {
		this.getMainData()
	},
	computed: {
		curProjectId() {
			return this.$route.query.projectId || null
		},
	},
	watch: {
		// 监听项目ID 的变化 
		curProjectId(val) {
			this.getMainData()
		}
	}
}
</script>

<style lang="less" scoped>
</style>